import React, { useEffect, useState } from 'react'

const Dommy = () => {

    let [data, setdata] = useState([])



    useEffect(() => {
        let localdata = localStorage.getItem("userDAta")
        if (localdata != null) {
            setdata(JSON.parse(localdata))

        } else {
            setdata([])
        }
    }, [data])


    let active = (statusindex) => {
        console.log(statusindex)
        //localStorage.setItem("userDAta", JSON.stringify(data))
        data[statusindex].status = 1
        setdata(data)
        localStorage.setItem("userDAta", JSON.stringify(data))
        // console.log(data[statusindex].status)
    }

    let inactive = (statusindex) => {
        console.log(statusindex)
        //localStorage.setItem("userDAta", JSON.stringify(data))

        data[statusindex].status = 0
        localStorage.setItem("userDAta", JSON.stringify(data))
        // console.log(data[statusindex].status)


    }
    return (
        <div>

            <div className='row '>
                <div className='col-lg-6'>



                    <div class="container">
                        <h2>Responsive Table</h2>
                        <p>The .table-responsive class adds a scrollbar to the table when needed:</p>

                        <div class="table-responsive">
                            <table class="table table-bordered">
                                <thead>
                                    <tr>
                                        <th>Firstname</th>
                                        <th>status</th>
                                        <th>Action</th>


                                    </tr>
                                </thead>
                                <tbody>
                                    {data.map((items, index) => {
                                        return (
                                            <tr>
                                                <td>{items.title}</td>
                                                <td>{items.status == 0 ? "In Active atiuser" : "Active user"}</td>
                                                <td>
                                                    <button className='btn btn-success' onClick={() => active(index)}>Active</button>
                                                    <button className='btn btn-primary' onClick={() => inactive(index)} >InActive</button>
                                                </td>

                                            </tr>
                                        )
                                    })}

                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

            </div>

        </div>

    )
}

export default Dommy